import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { KeycloakAngularModule } from 'keycloak-angular';
import { KeycloakServiceContext } from 'src/app/service/keycloak.service';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { initializeKeycloak } from './init/keycloak-init.factory';
import { ApiInterceptor } from './interceptor/api-interceptor';
import { API_SERVICE_TOKEN } from './service/api.service';
import { MainApiService } from './service/api.service-main';
import { MockedApiService } from './service/api.service-mock';
import { AuthService } from './service/auth.service';
import { SharedComponentsModule } from './shared-components/shared-components.module';

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        MatListModule,
        MatIconModule,
        AppRoutingModule,
        SharedComponentsModule,
        KeycloakAngularModule,
    ],
    providers: [
        {
            provide: API_SERVICE_TOKEN,
            useClass: environment.mock ? MockedApiService : MainApiService,
        },
        provideAppInitializer(() => {
        const initializerFn = (initializeKeycloak)(inject(KeycloakServiceContext), inject(AuthService));
        return initializerFn();
      }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})

// KeycloakService
export class AppModule {
    public matIconRegistry = inject(MatIconRegistry);

    constructor() {
        this.matIconRegistry.registerFontClassAlias('fontawesome', 'fa');
        this.matIconRegistry.registerFontClassAlias('brands', 'fab');
    }
}
